export default {
  methods: {
    // Call SocketIO to update event status for other staff
    ioEventStatus (payload) {
      payload.id = parseInt(payload.id)
      this.$echo
        .private('Company.Appointment.' + payload.id)
        .whisper('statusUpdate', payload)
    },
    // Call SocketIO to update event status for other staff
    ioEventLock (payload) {
      payload.id = parseInt(payload.id)
      this.$echo
        .private('Company.Appointment.' + payload.id)
        .whisper('updateLock', payload)
    },
    // Call SocketIO to update event for other staff
    ioEventUpdate (id) {
      id = parseInt(id)
      this.$echo
        .private('Company.Appointment.' + id)
        .whisper('update', id)
    },
    // Call SocketIO to remove event for other staff
    ioEventRemove (ids) {
      for (let id of ids) {
        id = parseInt(id)
        this.$echo
          .private('Company.Appointment.' + id)
          .whisper('remove', id)
      }
    }
  }
}
